import { useEffect, useState } from "react";
import { api } from "./api";

// Launch C: swap the hero/about photo for another image from the approved library (Alias only).
export function ImageChoice({ jobId, value, onChange }) {
  const [choices, setChoices] = useState(null);
  useEffect(() => { api.imageChoices(jobId).then(setChoices).catch(() => setChoices({})); }, [jobId]);
  if (!choices) return <p className="text-xs text-slate-500">Loading approved photos…</p>;
  const roles = Object.entries(choices).filter(([, c]) => !c.clientPhoto && c.options.length);
  if (!roles.length) return <p className="text-xs text-slate-500" data-testid="image-choice-none">No alternative approved photos for this website.</p>;
  const sel = value ? `${value.role}:${value.libraryId}` : "";
  return (
    <label className="block text-xs text-slate-400">
      Replace a photo with another approved photo (optional)
      <select value={sel} data-testid="image-choice-select"
        onChange={(e) => { const [role, libraryId] = e.target.value.split(":"); onChange(e.target.value ? { role, libraryId } : null); }}
        className="mt-1 w-full rounded-xl bg-slate-950 ring-1 ring-slate-700 p-3 text-sm text-slate-100 focus:outline-none focus:ring-amber-500">
        <option value="">Keep the current photos</option>
        {roles.map(([role, c]) => (
          <optgroup key={role} label={`${role === "hero" ? "Main (hero) photo" : "About photo"} — now: ${c.currentAlt || c.current}`}>
            {c.options.map((o) => <option key={o.id} value={`${role}:${o.id}`}>{o.alt}{o.photographer ? ` (${o.photographer})` : ""}</option>)}
          </optgroup>
        ))}
      </select>
    </label>
  );
}
